/* tslint:disable */
/* eslint-disable */
/**
 * 輸送ロット調整API
 * 重量、パレット数、容量制約に基づいてアイテムを輸送ロットに割り当てるAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Transport
 */
export interface Transport {
    /**
     * 輸送手段ID
     * @type {string}
     * @memberof Transport
     */
    transportTypeId: string;
    /**
     * 車両の容量の上限（キログラム）
     * @type {number}
     * @memberof Transport
     */
    maxWeight: number;
    /**
     * パレット最大積載枚数
     * @type {number}
     * @memberof Transport
     */
    maxPalletCount: number;
}

/**
 * Check if a given object implements the Transport interface.
 */
export function instanceOfTransport(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "transportTypeId" in value;
    isInstance = isInstance && "maxWeight" in value;
    isInstance = isInstance && "maxPalletCount" in value;

    return isInstance;
}

export function TransportFromJSON(json: any): Transport {
    return TransportFromJSONTyped(json, false);
}

export function TransportFromJSONTyped(json: any, ignoreDiscriminator: boolean): Transport {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transportTypeId': json['transport_type_id'],
        'maxWeight': json['max_weight'],
        'maxPalletCount': json['max_pallet_count'],
    };
}

export function TransportToJSON(value?: Transport | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transport_type_id': value.transportTypeId,
        'max_weight': value.maxWeight,
        'max_pallet_count': value.maxPalletCount,
    };
}

